var _style, _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "904.3px",
    height: "904.3px",
    viewBox: "0 0 904.3 904.3",
    style: {
      enableBackground: "new 0 0 904.3 904.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#3B414F;stroke-width:27.3187;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#3B414F;stroke-width:27.3187;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 456.4,
    cy: 499.8,
    r: 210.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 456.4,
    cy: 503.4,
    r: 43.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 456.4,
    y1: 289,
    x2: 456.4,
    y2: 460.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 456.4,
    y1: 546.5,
    x2: 456.4,
    y2: 717.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 242.4,
    y1: 499.8,
    x2: 413.3,
    y2: 499.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 499.6,
    y1: 499.8,
    x2: 667.3,
    y2: 499.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 305.1,
    y1: 347.3,
    x2: 426.1,
    y2: 468.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 487.2,
    y1: 529.4,
    x2: 607.8,
    y2: 650
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 607.8,
    y1: 344.1,
    x2: 486.7,
    y2: 465.1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 425.7,
    y1: 526.2,
    x2: 305.1,
    y2: 646.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 702.8,
    y1: 309.4,
    x2: 702.8,
    y2: 33.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "744.8,59.4 702.8,83.7 660.8,59.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "744.8,283.8 702.8,259.5 660.8,283.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 822.2,
    y1: 240.5,
    x2: 583.4,
    y2: 102.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "626.6,79.2 626.6,127.6 584.7,151.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "820.9,191.3 779,215.6 779,264  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 583.4,
    y1: 240.5,
    x2: 822.2,
    y2: 102.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "820.9,151.8 779,127.6 779,79.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "626.6,264 626.6,215.6 584.7,191.3  "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752.4,330.7c28.5,49.8,44.9,107.6,44.9,169.1c0,188.2-152.6,340.8-340.8,340.8S115.7,688,115.7,499.8 S268.3,159,456.5,159c27.4,0,54.1,3.2,79.7,9.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelcon);
export default __webpack_public_path__ + "static/media/wheelcon.e16a06f86ff9c635ca4d691c8286e789.svg";
export { ForwardRef as ReactComponent };